import React from 'react';
import { Container } from '../components.js';

class BuildSkillBox extends React.Component {

	render() {
		const containerSize = {
			width: (this.props.size) ? this.props.size.width : '22vmin',
			height: (this.props.size) ? this.props.size.height : '27vmin'
		};

		const title = this.props.title;
		const titleIcon = this.props.icon;
	  	const numOfSkills = (
	  		<div className="BuildSkillBox-Underline">
	  			<div className="BuildSkillBox-Left">{this.props.numOfSkills}</div>
	  			<div className="BuildSkillBox-Right">{'skills'}</div>
	  		</div>);
		const uniqueSkillsCompletions = (
			<div className="BuildSkillBox-Underline">
				<div className="BuildSkillBox-Left">{this.props.numCompleted}</div>
				<div className="BuildSkillBox-Right">{'skills completed'}</div>
			</div>
			);
		const uniqueUsers = (
			<div className="BuildSkillBox-Underline">
				<div className="BuildSkillBox-Left">{this.props.numUsers}</div>
				<div className="BuildSkillBox-Right">{'users building'}<br/>{'these skills'}</div>
			</div>
			);
		const uniqueLikes = (
			<div className="BuildSkillBox-Underline">
				<div className="BuildSkillBox-Left">{this.props.numLikes}</div>
				<div className="BuildSkillBox-Right">{'likes'}</div>
			</div>
			);
		const rewardsPaid = (
			<div className="BuildSkillBox-Bottom">
				<div className="BuildSkillBox-Left">{'$' + this.props.rewardsPaid}</div>
				<div className="BuildSkillBox-Right">{'rewards earned'}</div>
			</div>
			);

		const content = (
			<div className="BuildSkillBox">
				{numOfSkills}
				{uniqueUsers}
				{uniqueSkillsCompletions}
				{uniqueLikes}
				{rewardsPaid}
			</div>
			);

  		return (
  			<Container key={'buildskillbox' + this.props.title} 
  				moreClass={"Container-Stackable"} 
  				titles={[{'label' : (<div className="Container-BS-Title"><div className="Container-BS-Icon"><img src={titleIcon} alt='title icon' /></div><div className="Container-BS-Label"><div>{title}</div></div></div>), 'onClick' : ''}]} 
  				contents={content} 
  				size={containerSize} 
  				bgcolor="#f18d1b" 
  			/>
  		);
	}
}

export default BuildSkillBox;








